import { render, staticRenderFns } from "./dialog-change-price.vue?vue&type=template&id=4ff29431&scoped=true&"
import script from "./dialog-change-price.vue?vue&type=script&lang=js&"
export * from "./dialog-change-price.vue?vue&type=script&lang=js&"
import style0 from "./dialog-change-price.vue?vue&type=style&index=0&id=4ff29431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff29431",
  null
  
)

export default component.exports